import { ConfusedColors, confusedColors } from "./colors/confused";
import { colors, MojoColors } from "./colors/mojo";
import { MoneyColors, moneyColors } from "./colors/money";
import { UswitchColors, uswitchColors } from "./colors/uswitch";
import { ZooplaColors, zooplaColors } from "./colors/zoopla";
import { Breakpoints, devices } from "./devices";
import { Shadows, shadows } from "./shadows";
import { Size, size } from "./size";
import { Spacing, spacing } from "./spacing";

export type ThemeConfig = {
  /**
   * All Mojo and partner colors.
   * Mojo colors are duplicated under the `Mojo` object as well.
   */
  colors: MojoColors & {
    Uswitch: UswitchColors;
    Mojo: MojoColors;
    Money: MoneyColors;
    Confused: ConfusedColors;
    Zoopla: ZooplaColors;
  };

  /**
   * Spacing options, to be used for margins, paddings, etc.
   */
  spacing: Spacing;

  /**
   * Pre-defined breakpoints
   */
  breakpoints: Breakpoints;

  /**
   * Pre-defined border radius sizes
   */
  radius: Size;

  /**
   * Pre-defined box-shadow sizes
   */
  shadows: Shadows;
};

const mojoColors = {
  ...colors,
  primary: {
    one: colors.vivid[500],
    two: colors.neutral[900],
    three: colors.white,
  },
  secondary: {
    one: colors.vivid[0],
    two: colors.peach[100],
    three: colors.yellow[500],
  },
};

export const defaultTheme: ThemeConfig = {
  colors: {
    ...mojoColors,
    Mojo: mojoColors,
    Uswitch: uswitchColors,
    Money: moneyColors,
    Confused: confusedColors,
    Zoopla: zooplaColors,
  },

  spacing: spacing,

  shadows: shadows,

  breakpoints: devices,

  radius: size,
};
